import { Repeat } from 'lucide-react';
import type { LBNodeData } from '@/proto/logiblocks/logiblocks';
import { CONTROL_FLOW_ICON_COLOR } from '../../styles';
import {
  type GraphData,
  NodeCategory,
  OutputType,
  type LBNodeInfo,
} from '../../types';
import { Deprecated_FilteredShipmentsLoopCustomization } from './Deprecated_FilteredShipmentsLoopCustomization';
import { defaultNodeData } from '../../graphUtils';

export const Deprecated_FilteredShipmentsLoopNodeInfo: LBNodeInfo = {
  protobufNodeDataKey: 'deprecated_filtered_shipments_loop',

  category: NodeCategory.CONTROL_FLOW,

  label: 'Filter Shipments (deprecated)',

  hasInput: true,

  getIcon: (size: number) => (
    <Repeat size={size} color={CONTROL_FLOW_ICON_COLOR} />
  ),

  outputType: OutputType.SUBGRAPH_PARENT,

  getSubtitle: (data: LBNodeData, _graph: GraphData) => {
    const statusIds = data.deprecated_filtered_shipments_loop?.status_ids || [];
    const originIds =
      data.deprecated_filtered_shipments_loop?.origin_location_ids || [];
    const destIds =
      data.deprecated_filtered_shipments_loop?.destination_location_ids || [];

    const parts: string[] = [];
    if (statusIds.length > 0) parts.push(`Status: ${statusIds.join(', ')}`);
    if (originIds.length > 0) parts.push(`Origin: ${originIds.length}`);
    if (destIds.length > 0) parts.push(`Dest: ${destIds.length}`);

    return parts.length > 0 ? parts.join(' | ') : 'All';
  },

  CustomizationComponent: Deprecated_FilteredShipmentsLoopCustomization,

  getSubgraphIndex: (nodeData: LBNodeData) => {
    return nodeData.deprecated_filtered_shipments_loop?.subgraph_index;
  },

  setSubgraphIndex: (nodeData: LBNodeData, index: number) => {
    if (nodeData.deprecated_filtered_shipments_loop) {
      nodeData.deprecated_filtered_shipments_loop.subgraph_index = index;
    }
  },

  createDefaultNodeData: () =>
    defaultNodeData('deprecated_filtered_shipments_loop', {
      subgraph_index: -1,
      status_ids: [],
      origin_location_ids: [],
      destination_location_ids: [],
    }),
};
